import axios from 'axios';
import store from '@/store';
import toast from './toast';

export default function setup() {
    axios.interceptors.request.use(function (config) {
        config.headers.uilang = store.state.lang
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });
    axios.interceptors.response.use(function (response) {
        if (response.data.message != '') {
            // console.log(response.data.message)
            if (response.data.success) {
                toast.success(response.data.message)
            } else {
                toast.error(response.data.message)
            }
        }
        if (response.data.refresh_token) {
            // console.log('auth/SET_TOKEN')
            store.commit('auth/SET_TOKEN', response.data.refresh_token)
        }
        return response;
    }, function (error) {
        if (error.response.data.message != '') {
            // console.log(error.response.data.message)
            if (error.response.data.success) {
                toast.success(error.response.data.message)
            } else {
                toast.error(error.response.data.message)
            }

        }
        return Promise.reject(error);
    });
}